module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_12.f5a6bff50944ce57278a5a82c2655c5f.png";